import { NodeViewProps, NodeViewWrapper } from "@tiptap/react";
import { ParentComponent } from "~/utils/type-helpers";
import { IMentionAttributes } from "./utils";
import { GroupMentionSpan, UserMentionSpan } from "~/components/thread-timeline-entry/MessageEntry/ExpandedMessage";

export const MentionNodeView: ParentComponent<NodeViewProps> = (props) => {
  const attrs = props.node.attrs as IMentionAttributes;

  switch (attrs.subject) {
    case "user": {
      return (
        <NodeViewWrapper className="inline-flex">
          <UserMentionSpan
            {...props.HTMLAttributes}
            userId={attrs.id}
            priority={String(attrs.priority)}
            isCurrentUserSender
            dueDate={attrs.dueDate}
            requestComplete={attrs.requestComplete}
          />
        </NodeViewWrapper>
      );
    }
    case "group": {
      return (
        <NodeViewWrapper className="inline-flex">
          <GroupMentionSpan
            {...props.HTMLAttributes}
            groupId={attrs.id}
            priority={String(attrs.priority)}
            isCurrentUserSender
            dueDate={attrs.dueDate}
          />
        </NodeViewWrapper>
      );
    }
    default: {
      return <span {...props} />;
    }
  }
};
